import { connect } from 'react-redux';
import { notificationSelected } from '../../../state/actions';

const mapDispatch = (dispatch: Function) => ({
  async onRead(notificationId: number) {
    await dispatch(notificationSelected(notificationId));
  },
});

export const Connect = connect(null, mapDispatch);
